const SCALING_WHEN_WINDOW_WIDTH_LOWER = 700;
export { SCALING_WHEN_WINDOW_WIDTH_LOWER };
